<template>
    <base-dropdown
        placement="bottom"
        :fill="true"
    >
        <template
            v-slot:trigger="{
                open,
                toggle,
                isOpen
            }"
        >
            <div class="relative">
                <input
                    v-mask="'##/##/####'"
                    :value="value"
                    type="tel"
                    :name="name"
                    :placeholder="placeholder"
                    :disabled="disabled"
                    :autofocus="autofocus"
                    :class="[
                        $validator.has(validatorName, sid)
                            ? 'border-red hover:border-red-darker'
                            : 'hover:border-grey',
                        { 'bg-grey-bg cursor-not-allowed': disabled }
                    ]"
                    class="w-full px-4 pt-3 pb-2 pr-12 border rounded text-grey-darkest focus:border-blue focus:outline-none focus:shadow-outline"
                    @input="$emit('input', $event.target.value, $event)"
                    @blur="$emit('blur', $event.target.value, $event)"
                    @focus="$emit('focus', $event.target.value, $event)"
                >

                <button
                    type="button"
                    class="absolute inset-y-0 right-0 flex items-center px-3 pt-1 outline-none margin-px text-grey-darker focus:outline-none"
                    @click.prevent="toggle"
                >
                    <base-svg
                        name="icon-calendar-date"
                        class="w-6 h-6"
                        :class="{
                            'fill-primary-blue fill-secondary-blue-light': isOpen
                        }"
                    />
                </button>
            </div>
        </template>

        <template
            v-slot:menu="{
                close
            }"
        >
            <div
                ref="options"
                class="max-w-xs px-4 py-3 dropdown-menu mt-3px"
            >
                <base-calendar :value="valueAsDate || today">
                    <template
                        slot="header"
                        slot-scope="{ month, nextMonth, prevMonth }"
                    >
                        <div class="flex items-center ml-10">
                            <button
                                type="button"
                                @click.prevent="prevMonth"
                                class="w-6 h-6 focus:outline-none"
                            >
                                <base-svg
                                    name="icon-cheveron-left"
                                    class="w-full h-full fill-primary-white"
                                />
                            </button>

                            <div class="flex-grow text-sm font-semibold text-center text-white">
                                {{ month | moment('MMM YYYY') }}
                            </div>

                            <button
                                type="button"
                                @click.prevent="nextMonth"
                                class="w-6 h-6 focus:outline-none"
                            >
                                <base-svg
                                    name="icon-cheveron-right"
                                    class="w-full h-full fill-primary-white"
                                />
                            </button>

                            <button
                                type="button"
                                @click.prevent="close"
                                class="w-6 h-6 ml-4 focus:outline-none"
                            >
                                <base-svg
                                    name="icon-close"
                                    class="w-full h-full fill-primary-white"
                                />
                            </button>
                        </div>
                    </template>

                    <template
                        slot="weekday"
                        slot-scope="{ weekday }"
                    >
                        <div class="w-full font-bold text-center text-2xs text-grey-light">
                            {{ weekday }}
                        </div>
                    </template>

                    <template
                        slot="date"
                        slot-scope="{ date }"
                    >
                        <template v-if="date.is_current_month">
                            <button
                                type="button"
                                class="w-full h-full py-1 text-xs font-bold text-center text-white rounded"
                                :class="[
                                    valueAsDate && valueAsDate.isSame(date.date, 'day')
                                        ? 'bg-blue border-blue! hover:bg-blue-dark'
                                        : 'hover:bg-grey-dark',
                                    { 'border border-grey-dark': date.is_today }
                                ]"
                                @click.prevent="selectDate(date, close)"
                            >
                                {{ date.date | moment('D') }}
                            </button>
                        </template>
                        <template v-else>
                            &nbsp;
                        </template>
                    </template>
                </base-calendar>
            </div>
        </template>
    </base-dropdown>
</template>

<script>
    // import _ from 'lodash'
    import { mask } from 'vue-the-mask'
    import moment from 'moment'
    import BaseCalendar from './base-calendar'

    export default {
        components: {
            BaseCalendar
        },
        directives: {
            mask
        },
        props: {
            value: {
                validator: value => typeof value === 'string' || value === null,
                default: null
            },
            sid: {
                type: String,
                required: true
            },
            name: {
                type: String,
                required: true
            },
            validatorName: {
                type: String,
                required: false,
                default () {
                    return this.name.replace('[', '.').replace(']', '')
                }
            },
            placeholder: {
                type: String,
                default: 'dd/mm/yyyy'
            },
            autofocus: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                valueAsDate: null
            }
        },
        computed: {
            today () {
                return moment()
            }
        },
        watch: {
            value () {
                this.setValueAsDate()
            }
        },
        created () {
            this.setValueAsDate()
        },
        methods: {
            selectDate (date, close) {
                this.$emit('input', date.date.format('DD/MM/YYYY'))

                close()
            },
            setValueAsDate () {
                if (this.value && this.value.length === 10 && moment(this.value, 'DD/MM/YYYY').isValid()) {
                    this.valueAsDate = moment(this.value, 'DD/MM/YYYY')
                } else {
                    this.valueAsDate = null
                }
            }
        }
    }
</script>
